import React from 'react';

/** Tools that open the shared Preview panel — not listed in the chatbot + menu. */
const PREVIEW_PANEL_TOOLS = new Set([
  'gmail',
  'image-editor',
  'video-editor',
  'website-builder',
  'idea-generation',
  'prompt-presets',
]);

export const UNIFIED_TOOLS = [
  {
    key: 'google-drive',
    label: 'Google Drive',
    kind: 'chatbot_action',
    icon: 'google_drive_svg',
    showIn: { homepagePlus: true, homepageQuick: true, chatbotPlus: true },
  },
  {
    key: 'onedrive',
    label: 'OneDrive',
    kind: 'chatbot_action',
    icon: 'onedrive_svg',
    showIn: { homepagePlus: true, homepageQuick: true, chatbotPlus: true },
  },
  {
    key: 'gmail',
    label: 'Gmail',
    kind: 'chatbot_action',
    icon: 'gmail_svg',
    showIn: { homepagePlus: false, homepageQuick: true, chatbotPlus: false },
  },
  {
    key: 'image-editor',
    label: 'Image Editor',
    kind: 'chatbot_action',
    icon: 'image_emoji',
    showIn: { homepagePlus: false, homepageQuick: false, chatbotPlus: false },
  },
  {
    key: 'video-editor',
    label: 'Video Editor',
    kind: 'chatbot_action',
    icon: 'video_emoji',
    showIn: { homepagePlus: false, homepageQuick: false, chatbotPlus: false },
  },
  {
    key: 'website-builder',
    label: 'Website Builder',
    kind: 'chatbot_action',
    icon: 'web_emoji',
    showIn: { homepagePlus: false, homepageQuick: false, chatbotPlus: false },
  },
  {
    key: 'idea-generation',
    label: 'Idea Generation',
    kind: 'chatbot_action',
    icon: 'idea_emoji',
    showIn: { homepagePlus: false, homepageQuick: false, chatbotPlus: false },
  },
  {
    key: 'camera',
    label: 'Camera',
    kind: 'chatbot_action',
    icon: 'camera_emoji',
    showIn: { homepagePlus: false, homepageQuick: false, chatbotPlus: false },
  },
  {
    key: 'zolaid-computer',
    label: 'Preview panel',
    kind: 'chatbot_action',
    icon: 'computer_emoji',
    showIn: { homepagePlus: false, homepageQuick: false, chatbotPlus: false },
  },
  {
    key: 'prompt-presets',
    label: 'Prompt Presets',
    kind: 'chatbot_action',
    icon: 'prompt_emoji',
    showIn: { homepagePlus: false, homepageQuick: false, chatbotPlus: false },
  },
];

export const UnifiedIcons = {
  gmail_svg: ({ className = 'gmail-logo' }) => (
    <svg className={className} viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path fill="#EA4335" d="M20 6.5V18c0 .55-.45 1-1 1h-2V9.7l-5 3.75-5-3.75V19H5c-.55 0-1-.45-1-1V6.5l8 6 8-6z" />
      <path fill="#FBBC04" d="M20 6.5l-8 6-8-6V6c0-.55.45-1 1-1h1l6 4.5L18 5h1c.55 0 1 .45 1 1v.5z" />
      <path fill="#34A853" d="M7 9.7V19H5c-.55 0-1-.45-1-1V6.5l3 3.2z" />
      <path fill="#4285F4" d="M20 6.5V18c0 .55-.45 1-1 1h-2V9.7l3-3.2z" />
    </svg>
  ),
  google_drive_svg: ({ className = 'drive-logo' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M7.71 2L2 13l5.71 11h8.58L22 13 16.29 2H7.71z" fill="#4285F4" />
      <path d="M9.71 13l-3.42 6.59L2 13h7.71z" fill="#34A853" />
      <path d="M22 13l-5.71 11h-5.71L16.29 13H22z" fill="#FBBC04" />
      <path d="M7.71 13L2 13l5.71 11 5.71-11H7.71z" fill="#EA4335" />
    </svg>
  ),
  onedrive_svg: ({ className = 'onedrive-logo' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M12.5 3.5c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5c.3 0 .6 0 .9-.1l-1.4 2.4c-.3.5-.1 1.1.4 1.4.5.3 1.1.1 1.4-.4l2.1-3.5c.2-.3.3-.7.3-1.1 0-2.5-2-4.5-4.5-4.5z" fill="#0078D4" />
      <path d="M19.5 12.5c-1.4 0-2.6.8-3.2 2l-2.1 3.5c-.3.5-.1 1.1.4 1.4.5.3 1.1.1 1.4-.4l1.4-2.4c.3.1.6.1.9.1 2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5z" fill="#0078D4" />
    </svg>
  ),
};

export const getUnifiedEmoji = (iconKey) => {
  if (iconKey === 'chart_emoji') return '📊';
  if (iconKey === 'image_emoji') return '🖼️';
  if (iconKey === 'video_emoji') return '🎬';
  if (iconKey === 'web_emoji') return '🌐';
  if (iconKey === 'idea_emoji') return '💡';
  if (iconKey === 'camera_emoji') return '📷';
  if (iconKey === 'computer_emoji') return '💻';
  if (iconKey === 'prompt_emoji') return '💡';
  return '';
};

export const getUnifiedToolsFor = (surface) => {
  const key = String(surface || '').trim();
  return UNIFIED_TOOLS.filter((t) => {
    if (!t?.showIn) return false;
    if (key === 'homepagePlus' || key === 'chatbotPlus') {
      // Homepage + and chatbot + share one list. Preview-panel tools stay off this menu.
      if (PREVIEW_PANEL_TOOLS.has(t.key)) return false;
      return Boolean(t.showIn.chatbotPlus || t.showIn.homepagePlus);
    }
    if (key === 'homepageQuick') return Boolean(t.showIn.homepageQuick);
    return false;
  });
};
